import { cn } from '../../lib/utils';

// How much of its cost an item has earned back, drawn as a bar that fills to
// what it cost. Past 100% the bar is full and turns moss: it has paid for
// itself.
export function PaidBackBar({ percent, inverse = false, className }) {
  const over = percent >= 100;
  return (
    <div
      className={cn('relative h-2 rounded-pill overflow-hidden', inverse ? 'bg-inverse-muted/30' : 'bg-mist', className)}
      role="progressbar"
      aria-label="Paid back"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(Math.min(percent, 100))}
    >
      <div
        className={cn(
          'absolute inset-y-0 left-0 rounded-pill transition-[width,background-color] duration-700 ease-out',
          over ? 'bg-moss' : inverse ? 'bg-inverse-foreground' : 'bg-foreground',
        )}
        style={{ width: `${Math.min(percent, 100)}%` }}
      />
    </div>
  );
}
